<template>
	<div>
		<div class="list-group border-radius-2 no-border mb-3">
			<WidgetHeader link="/timetables/placements">{{ $t("placement-events") }}</WidgetHeader>
		</div>
		<PlacementEventsList
			:placementevents="placementevents"
		></PlacementEventsList>
		<template v-if="total">
			<router-link to="/timetables/placements" class="btn btn-primary">View all {{total}} placement events</router-link>
		</template>
	</div>
</template>

<script>
import WidgetHeader from "src/components/widgets/WidgetHeader";
import PlacementEventsList from "src/components/Placements/PlacementEventsList";

export default {
	components: {
		WidgetHeader,
		PlacementEventsList
	},
	data() {
		return {
			total: 0,
			placementevents: []
		};
	},
	mounted() {
		this.getPlacements();
	},
	methods: {
		getPlacements(){
			this.$cfetch(`${this.$settings.APIBaseURL}/placements/myplacements`, {
				cache: false,
				method: 'post',
				data: {
					'page_size': 3
				}
			})
			.then(res => {
				if (res.status === "SUCCESS") {
					res.results.map(event => {
						event.students.map(student => {
							student.displayname = ''
						});
					});
					this.placementevents = res.results;
					this.placementevents.map(event => {
						event.students.map(student => {
							this.$users.getDisplayName.call(this , student.id).then(result => {
								student.displayname = result
							});
						});
					});
					this.total = res.pagination.total
				} else {
					this.$log.error.call(this, "Could not fetch placements");
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
			});
		}
	}
};
</script>
